"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isObject2 = _interopRequireDefault(require("lodash/isObject"));

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TYPES = ['primary', 'secondary', 'destructive', 'borderless', 'dark-primary', 'dark-secondary', 'dark-destructive', 'dark-borderless', 'icon-default', 'icon-link', 'icon-dark'];
/**
 * Common Button component.
 */

var Button =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Button, _React$Component);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, _getPrototypeOf(Button).apply(this, arguments));
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          disabled = _this$props.disabled,
          fullWidth = _this$props.fullWidth,
          appearance = _this$props.appearance,
          type = _this$props.type,
          children = _this$props.children,
          htmlType = _this$props.htmlType,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseLeave = _this$props.onMouseLeave,
          props = _objectWithoutProperties(_this$props, ["className", "disabled", "fullWidth", "appearance", "type", "children", "htmlType", "onMouseEnter", "onMouseLeave"]); // Determine button appearance
      // Note: Default appearance will change to square format for single objects


      var aspect = appearance;

      if (!(0, _isArray2.default)(children) && (0, _isObject2.default)(children) && aspect !== 'mini') {
        aspect = 'square';
      } // Conditional props. See explanation below on React bug.


      var additionalProps = {};

      if (!(disabled && onMouseLeave)) {
        additionalProps = {
          onMouseEnter: onMouseEnter,
          onMouseLeave: onMouseLeave
        };
      }

      var width = fullWidth ? 'full-width' : '';

      var clsPrfx = _ThemeManager.default.getVar('classPrefix');

      var button = _react.default.createElement("button", _extends({
        type: htmlType,
        className: (0, _classnames.default)(className, "".concat(clsPrfx, " ").concat(clsPrfx, "-button")),
        "data-type": type,
        "data-appearance": aspect,
        "data-width": width,
        disabled: disabled
      }, props, additionalProps), _react.default.Children.map(children, function (child) {
        return typeof child === 'string' ? _react.default.createElement("span", null, child) : child;
      })); // There is a bug on React 15 & 16 where mouseLeave does not get triggered on disabled
      // buttons. Therefore we must clone and render the button a little differently in disabled
      // conditions. This may be fixed in React 17. Workaround is combination of
      //   1) Wrap disabled button in another DOM element, and
      //   2) add point events none so the events on the button become ignored which
      //      disable bubbling up to the wrapper.
      // See https://github.com/facebook/react/issues/4251 for more info.


      if (disabled && onMouseLeave) {
        return _react.default.createElement("span", {
          className: "".concat(clsPrfx, "-button-wrap ").concat(clsPrfx),
          onMouseEnter: onMouseEnter,
          onMouseLeave: onMouseLeave
        }, button);
      }

      return button;
    }
  }]);

  return Button;
}(_react.default.Component);

exports.default = Button;
Button.propTypes = {
  /**
   * Customize additional class name.
   */
  className: _propTypes.default.string,

  /**
   * Button text or an element such as an icon.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Disable button events and state. Note: When onMouseLeave is triggered with `disabled` the
   * event when paired with onMouseEnter creates an asysmetrical behavior. Therefore a `<span>`
   * wrapper is created around the button to keep the event firing consistent.
   */
  disabled: _propTypes.default.bool,

  /**
   * Type of button.
   */
  type: _propTypes.default.oneOf(TYPES),

  /**
   * Appearance of button:
   *   'default' - Default appearance.
   *   'square' - Square shaped button (Default will transform to this for
   *.             single node elements).
   *   'mini' - Bite size button generally used for single icon use.
   */
  appearance: _propTypes.default.string,

  /**
   * Make button 100% width and behave like a block element.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * Callback function to handle onClick of the button.
   */
  onClick: _propTypes.default.func,

  /**
   * Callback function to handle onMouseEnter of the button.
   *
   * @ignore
   */
  onMouseEnter: _propTypes.default.func,

  /**
   * Callback function to handle onMouseLeave of the button.
   *
   * @ignore
   */
  onMouseLeave: _propTypes.default.func,

  /**
   * HTML Type of button.
   */
  htmlType: _propTypes.default.oneOf(['submit', 'button', 'reset'])
};
Button.defaultProps = {
  type: 'primary',
  appearance: 'default',
  fullWidth: false,
  htmlType: 'button'
};